import type { GoogleProtobufTimestamp, GoogleProtobufTimestampInput } from "../../../../gql-generated/types";

export const DateConvert = {
    toTimestamp(datetime: Date): GoogleProtobufTimestampInput | null {
        if (!datetime) {
            return null;
        }

        return {
            nanos: 0,
            seconds: Math.floor(datetime.valueOf() / 1000),
        };
    },

    toDate(datetime: Partial<GoogleProtobufTimestamp> | null | undefined): Date | null {
        if (!datetime) {
            return null;
        }

        const seconds = Number.isInteger(datetime.seconds) ? (datetime.seconds as number) : 0;

        return new Date(seconds * 1000);
    },
};
